import React from 'react';
import { Navbar } from '../components/Navbar';
import { VideoPage } from '../components/VideoPage';
import { Footer } from '../components/Footer';
export const Video = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2373">
      <Navbar data-id="element-2374" />
      <VideoPage data-id="element-2375" />
      <Footer data-id="element-2376" />
    </div>;
};